const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class UncertainBorders extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.UncertainBorders,
            "The strongest civilization takes 1 yellow token from the weakest civilization's yellow bank.",
            {}
        )
    }
}

module.exports = UncertainBorders;